import axios from 'axios'
import { productUrl, productCategoryUrl, productTypeUrl, getHeader } from './../config'

const state = {
  productByPriceList: [],
  productList: [],
  productTotalList: [],
  productCategoryList: [],
  productTypeList: [],
  product: {},
  productListAll: [],
  productAccounTypeList: [],
  productTemplateList: [],
  productByVariant: [],
  productPackageList: [],
  productPackageGroupList: [{
    id: null,
    category: null
  }],
  productListSelect: [],
  productListCogs: [{
    id: null,
    product_no: null,
    product_name: null
  }],
  productListPrice: [],
  productPriceLatest: {},
  productCostByNo: [],
  productUomByNo: []
}

const mutations = {
  SET_PRODUCT_BY_NO (state, obj) {
    state.product = obj
  },
  SET_PRODUCT_LIST_ALL (state, obj) {
    state.productListAll = obj
  },
  SET_PRODUCT_LIST (state, obj) {
    state.productList = obj
  },
  SET_PRODUCT_CATEGORY_LIST (state, obj) {
    state.productCategoryList = obj
  },
  SET_PRODUCT_TYPE_LIST (state, obj) {
    state.productTypeList = obj
  },
  SET_PRODUCT_BY_PRICE_LIST (state, obj) {
    state.productByPriceList = obj
  },
  SET_PRODUCT_ACCOUNT_TYPE_LIST (state, obj) {
    state.productAccounTypeList = obj
  },
  SET_PRODUCT_TEMPLATE_LIST (state, obj) {
    state.productTemplateList = obj
  },
  SET_PRODUCT_BY_VARIANT (state, obj) {
    state.productByVariant = obj
  },
  SET_PRODUCT_PACKAGE_LIST (state, obj) {
    state.productPackageList = obj
  },
  SET_PRODUCT_PACKAGE_GROUP_LIST (state, obj) {
    state.productPackageGroupList = obj
  },
  SET_PRODUCT_LIST_SELECT (state, obj) {
    state.productListSelect = obj
  },
  SET_PRODUCT_LIST_COGS (state, obj) {
    state.productListCogs = obj
  },
  SET_PRODUCT_LIST_PRICE (state, obj) {
    state.productListPrice = obj
  },
  SET_PRODUCT_PRICE_LATEST (state, obj) {
    state.productPriceLatest = obj
  },
  SET_PRODUCT_COST_BY_NO (state, obj) {
    state.productCostByNo = obj
  },
  SET_PRODUCT_UOM_BY_NO (state, obj) {
    state.productUomByNo = obj
  },
  SET_PRODUCT_TOTAL_LIST (state, obj) {
    state.productTotalList = obj
  }
}

const actions = {
  getProductByNo: ({ commit }, payload) => {
    axios.post(productUrl + '/get-product-no', payload, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_PRODUCT_BY_NO', response.data.data)
      })
  },
  getProductUomByNo: ({ commit }, payload) => {
    console.log(productUrl)
    axios.post(productUrl + '/uom/list', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_UOM_BY_NO', response.data.data)
      })
  },
  getProductCogsByNo: ({ commit }, payload) => {
    console.log('cost/get-product')
    axios.post(productUrl + '/cost/get-product', payload, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_PRODUCT_COST_BY_NO', response.data.data)
      })
  },
  getProductListCogs: ({ commit }, payload) => {
    console.log('trigger product list cogs')
    axios.post(productUrl + '/list-cogs', payload, { headers: getHeader() })
      .then(response => {
        console.log('success product list cogs')
        commit('SET_PRODUCT_LIST_COGS', response.data.data)
      })
  },
  getProductListPrice: ({ commit }, payload) => {
    axios.post(productUrl + '/list-price', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_LIST_PRICE', response.data.data)
      })
  },
  getProductPackageGroupList: ({ commit }) => {
    axios.get(productUrl + '/package-group', { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_PACKAGE_GROUP_LIST', response.data.data)
      })
  },
  getProductTemplateList: ({ commit }) => {
    axios.get(productUrl + '/template?active=true', { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_TEMPLATE_LIST', response.data.data)
      })
  },
  getProductAccountTypeLst: ({ commit }) => {
    axios.get(productUrl + '/account/type', { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_ACCOUNT_TYPE_LIST', response.data.data)
      })
  },
  getProductByPriceList: ({ commit, state }, payload) => {
    console.log('getProductByPriceList')
    var url = productUrl + '/list?price-id=' + payload.priceID + '&branch=' + payload.branch + '&warehouse=' + payload.warehouse + '&date=' + payload.date
    console.log(url)
    axios.get(url, { headers: getHeader() })
      .then(response => {
        console.log('get product price list')
        console.log(response.data.data)
        commit('SET_PRODUCT_LIST', response.data.data)
      })
  },
  getProductWithTotal: ({ commit, state }, payload) => {
    var url = productUrl + '/list/total'
    console.log('getProductWithTotal')
    console.log(payload)
    console.log(url)
    axios.post(url, payload, { headers: getHeader() })
      .then(response => {
        console.log('get product total list')
        console.log(response.data.data)
        commit('SET_PRODUCT_TOTAL_LIST', response.data.data)
      })
  },
  getProductById: ({ commit }) => {
    axios.get(productUrl + '/' + commit, { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_LIST', response.data.data)
      })
  },
  getProductCategoryList: ({ commit }) => {
    axios.get(productCategoryUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_CATEGORY_LIST', response.data.data)
      })
  },
  getProductTypeList: ({ commit }) => {
    axios.get(productTypeUrl, { headers: getHeader() })
      .then(response => {
        console.log('product type')
        console.log(response.data.data)
        commit('SET_PRODUCT_TYPE_LIST', response.data.data)
      })
  },
  getProductList: ({ commit }) => {
    axios.get(productUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_PRODUCT_LIST_ALL', response.data.data)
      })
  },
  getProductListSelect: ({ commit }) => {
    console.log('getProductListSelect')
    axios.get(productUrl + '/list-select', { headers: getHeader() })
      .then(response => {
        console.log(response.data.message)
        console.log(response.data.data)
        commit('SET_PRODUCT_LIST_SELECT', response.data.data)
      })
  },
  getProductPackageList: ({ commit }) => {
    axios.get(productUrl + '?category=36', { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_PRODUCT_PACKAGE_LIST', response.data.data)
      })
  },
  getProductByVariant: ({ commit }) => {
    axios.get(productUrl + '/list-variant', { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_BY_VARIANT', response.data.data)
      })
  },
  getProductPriceLatest: ({ commit }) => {
    axios.get(productUrl + '/latest-price', { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_PRICE_LATEST', response.data.data)
      })
  }
}

const getters = {
  getSalesTypeById: (state) => (id) => {
    return state.salesTypeList.find(s => s.id === id)
  }
}

export default {
  state, mutations, actions, getters
}
